import React, { ReactElement } from 'react'
import { UpsertEventType } from './UpsertEventType'
import { UpsertModal } from '../../../../components'
import { useTranslations } from 'hooks'
import { EventType } from 'libs/api'
import translations from '../Actions.i18n.json'

interface Props {
  children: ({ open }: { open: () => void }) => ReactElement
  refetch: () => Promise<unknown>
  item?: EventType
}

export function UpsertEventTypeModal({ children, refetch, item }: Props) {
  const labels = useTranslations(translations)

  return (
    <UpsertModal labels={labels} Modal={UpsertEventType} item={item} onSuccess={refetch}>
      {children}
    </UpsertModal>
  )
}
